import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { usePersonalDetails } from 'Hooks';
import { NoImageAvatar } from 'Images';

export const User = () => {
  const personalDetails = usePersonalDetails();

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <Avatar alt='' src={NoImageAvatar} />
      <Typography variant='h3' color={'initial'} component='h2'>
        {Dictionary[DICTIONARY.Home].helloName(
          (personalDetails?.firstName || '') +
            ' ' +
            (personalDetails?.lastName || '')
        )}
      </Typography>
    </Stack>
  );
};
